import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import ActionsDropdown from './component';
import { layoutSelectInput, layoutDispatch, layoutSelect } from '../../layout/context';
import { SMALL_VIEWPORT_BREAKPOINT } from '../../layout/enums';
import {
  useIsCameraAsContentEnabled,
  useIsPresentationEnabled,
  useIsTimerFeatureEnabled,
  useIsDownloadPresentationWithAnnotationsEnabled,
} from '/imports/ui/services/features';
import { PluginsContext } from '/imports/ui/components/components-data/plugin-context/context';
import { useShortcut } from '/imports/ui/core/hooks/useShortcut';
import {
  PROCESSED_PRESENTATIONS_SUBSCRIPTION,
} from '/imports/ui/components/whiteboard/queries';
import useDeduplicatedSubscription from '/imports/ui/core/hooks/useDeduplicatedSubscription';
import { SET_PRESENTER } from '/imports/ui/core/graphql/mutations/userMutations';
import { TIMER_ACTIVATE, TIMER_DEACTIVATE } from '../../timer/mutations';
import Auth from '/imports/ui/services/auth';
import { PRESENTATION_SET_CURRENT, PRESENTATION_EXPORT } from '../../presentation/mutations';
import { useStorageKey } from '/imports/ui/services/storage/hooks';
import { updateCurrentStatusPresndPage, useMeetingIsBreakout } from '/imports/ui/components/app/service';
import { courseSelect } from '../../app/context';

const ActionsDropdownContainer = (props) => {
  const sidebarContent = layoutSelectInput((i) => i.sidebarContent);
  const sidebarNavigation = layoutSelectInput((i) => i.sidebarNavigation);
  const { width: browserWidth } = layoutSelectInput((i) => i.browser);
  const isMobile = browserWidth <= SMALL_VIEWPORT_BREAKPOINT;
  const layoutContextDispatch = layoutDispatch();
  const isRTL = layoutSelect((i) => i.isRTL);
  const { pluginsExtensibleAreasAggregatedState } = useContext(PluginsContext);
  const meetingIsBreakout = useMeetingIsBreakout();
  const courseDetails = courseSelect((state) => state);
  const prepareLesson = courseDetails?.course?.courseDetail?.isPrepareLesson ?? false
  const deviceType = layoutSelect((i) => i.deviceType);
  let actionButtonDropdownItems = [];
  if (pluginsExtensibleAreasAggregatedState.actionButtonDropdownItems) {
    actionButtonDropdownItems = [
      ...pluginsExtensibleAreasAggregatedState.actionButtonDropdownItems,
    ];
  }

  const openActions = useShortcut('openActions');

  const { data: presentationData } = useDeduplicatedSubscription(
    PROCESSED_PRESENTATIONS_SUBSCRIPTION,
  );
  const presentations = presentationData?.pres_presentation || [];

  const {
    allowPresentationManagementInBreakouts,
  } = window.meetingClientSettings.public.app.breakouts;

  const isPresentationManagementDisabled = meetingIsBreakout
    && !allowPresentationManagementInBreakouts;

  const [setPresenter] = useMutation(SET_PRESENTER);
  const [timerActivate] = useMutation(TIMER_ACTIVATE);
  const [timerDeactivate] = useMutation(TIMER_DEACTIVATE);
  const [presentationSetCurrent] = useMutation(PRESENTATION_SET_CURRENT);
  const [presentationExport] = useMutation(PRESENTATION_EXPORT);

  const handleTakePresenter = () => {
    setPresenter({ variables: { userId: Auth.userID } });
  };

  const setPresentation = (presentationId) => {


    if(prepareLesson){
      presentationSetCurrent({ variables: { presentationId } });

      const apiPayload = {
        type: "presentation",
        presentationId
      };

      updateCurrentStatusPresndPage(apiPayload)
        .then((res) => {
          // success
        })
        .catch((error) => {
          console.log({ error });
        });
    }else{
        // Step 1: Ask other page to finish its job
        window.dispatchEvent(
          new CustomEvent("presentation-change", {
            detail: { isChangeReq: true, presentationId }
          })
        );

        // Step 2: Wait for DONE event
        waitForPresentationDone().then(() => {
          // Step 3: Now run your actual logic
          presentationSetCurrent({ variables: { presentationId } });

          const apiPayload = {
            type: "presentation",
            presentationId
          };

          updateCurrentStatusPresndPage(apiPayload)
            .then((res) => {
              // success
            })
            .catch((error) => {
              console.log({ error });
            });
        });
    }
   
  };
  const waitForPresentationDone = () => {
    return new Promise((resolve) => {
      const handler = (event) => {
        if (event.detail?.isChanged) {
          window.removeEventListener("presentation-change-done", handler);
          resolve(true);
        }
      };

      window.addEventListener("presentation-change-done", handler);
    });
  };

  const activateTimer = () => {
    const TIMER_CONFIG = window.meetingClientSettings.public.timer;
    const MILLI_IN_MINUTE = 60000;
    const stopwatch = true;
    const running = true;
    const time = TIMER_CONFIG.time * MILLI_IN_MINUTE;

    timerActivate({ variables: { stopwatch, running, time } });
  };

  const isDropdownOpen = useStorageKey('dropdownOpen');
  const isPresentationEnabled = useIsPresentationEnabled();
  const isTimerFeatureEnabled = useIsTimerFeatureEnabled();
  const isCameraAsContentEnabled = useIsCameraAsContentEnabled();
  const allowDownloadWithAnnotations = useIsDownloadPresentationWithAnnotationsEnabled();

  // Get current presentation
  const currentPresentation = presentations.find((p) => p.current);

  // Handle downloading presentation with annotations
  const handleDownloadingOfPresentation = () => {
    if (currentPresentation) {
      presentationExport({
        variables: {
          presentationId: currentPresentation.presentationId,
          fileStateType: 'Annotated',
        },
      });
    }
  };

  return (
    <ActionsDropdown
      {...{
        layoutContextDispatch,
        sidebarContent,
        sidebarNavigation,
        isMobile,
        isRTL,
        actionButtonDropdownItems,
        presentations,
        isTimerFeatureEnabled,
        isDropdownOpen,
        setPresentation,
        isCameraAsContentEnabled,
        handleTakePresenter,
        activateTimer,
        deactivateTimer: timerDeactivate,
        shortcuts: openActions,
        isPresentationEnabled,
        isPresentationManagementDisabled,
        currentPresentation,
        allowDownloadWithAnnotations,
        handleDownloadingOfPresentation,
        deviceType,
        ...props,
      }}
    />
  );
};

export default ActionsDropdownContainer;
